import { useMemo } from 'react'
import { CraftGlobals } from 'tsconfig/craft-types'
import { CAboutVideo, CAboutVideoBlock } from './c-about-video'
import {
  CBackgroundImageCopy,
  CBackgroundImageCopyBlock,
} from './c-background-image-copy'
import { CComparisonTable, CComparisonTableBlock } from './c-comparison-table'
import { CCopyBlock, CCopyBlockBlock } from './c-copy-block'
import { CFindADoctor, CFindADoctorBlock } from './c-find-a-doctor'
import { CImageCopyBlocks, CImageCopyBlocksBlock } from './c-image-copy-blocks'
import { CJotFormEmbed, CJotFormEmbedBlock } from './c-jot-form-embed'
import {
  CSplitTestimonial,
  CSplitTestimonialBlock,
} from './c-split-testimonial'
import { CStats, CStatsBlock } from './c-stats'
import {
  CTestimonialsSlider,
  CTestimonialsSliderBlock,
} from './c-testimonials-slider'

type Props = {
  field: Array<
    | CAboutVideoBlock
    | CBackgroundImageCopyBlock
    | CComparisonTableBlock
    | CFindADoctorBlock
    | CImageCopyBlocksBlock
    | CSplitTestimonialBlock
    | CStatsBlock
    | CTestimonialsSliderBlock
    | CCopyBlockBlock
    | CJotFormEmbedBlock
  >
  global: CraftGlobals
}

export const CCustomComponentsLp = ({ field, global }: Props) => {
  const content = Array.isArray(field) ? field : []

  return (
    <div>
      {content.map((block, index) => {
        switch (block.typeHandle) {
          case 'aboutVideo':
            return <CAboutVideo key={index} field={global.aboutVideo} />

          case 'backgroundImageCopy':
            return (
              <CBackgroundImageCopy
                key={index}
                field={global.backgroundImageCopy}
              />
            )

          case 'comparisonTable':
            return (
              <CComparisonTable
                key={index}
                field={global.comparisonTable}
              />
            )

          case 'findADoctor':
            return <CFindADoctor key={index} field={global.findADoctor} />

          case 'imageCopyBlocks':
            return (
              <CImageCopyBlocks
                key={index}
                field={global.imageCopyBlocks}
              />
            )

          case 'splitTestimonial':
            return (
              <CSplitTestimonial
                key={index}
                field={global.splitTestimonial}
              />
            )

          case 'stats':
            return <CStats key={index} field={global.stats} />

          case 'testimonialsSlider':
            return (
              <CTestimonialsSlider
                key={index}
                field={global.testimonialsSlider}
              />
            )

          case 'copyBlock':
            return <CCopyBlock key={index} field={[block]} />

          case 'jotFormEmbed':
            return (
              <CJotFormEmbed
                key={index}
                field={[block as CJotFormEmbedBlock]}
              />
            )
        }

        return null
      })}
    </div>
  )
}

export { CCustomComponentsLpFragments } from '../../fragments/c-custom-components-lp'
